import { Helmet } from "react-helmet-async";
import Screen from "../../Layouts/Screen/Screen";
import { useState } from "react";
import "./style.css"
import ItemList from "../../../components/ItemList/ItemList";
import { Bell } from "react-feather";

interface AudioItem {
    name: string;
    file: string;
}

const NotificationsSettings = () => {      
    const audios: AudioItem[] = [
        { name: "Ding", file: "/audio/notifications/ding-126626.mp3" },
        { name: "Level up", file: "/audio/notifications/level-up-191997.mp3" },
        { name: "Livechat", file: "/audio/notifications/livechat-129007.mp3" },
        { name: "Livechat 2", file: "/audio/notifications/notification-2-269292.mp3" },
        { name: "Notification", file: "/audio/notifications/notification-18-270129.mp3" }
      ];
    
      const [selectedAudio, setSelectedAudio] = useState<string | null>(
        localStorage.getItem("notificationSound") || null
      );
      const [audioPreview] = useState(new Audio());
    
      const playPreview = (audioFile: string) => {
        audioPreview.src = audioFile;
        audioPreview.play();
      };
    
      const setNotificationSound = (audioFile: string) => {
        const formattedFile = audioFile.replaceAll("/", "_");
        localStorage.setItem("notificationSound", formattedFile);
        localStorage.setItem("notificationLocation", audioFile);
        setSelectedAudio(formattedFile);
      };

    return (
        <>
            <Screen paddingTopTitle={true} title="Notificações">
                <Helmet>
                        <title>Paçoca - Configurar notificações</title>
                        <meta name="description" content={`Configurar notificações do Paçoca!`}/>
                        <meta name="keywords" content={`Paçoca, rede social brasileira, Configurar notificações, notificação}`}/>
                        <meta name="author" content="Paçoca Inc."/>
                        <meta property="og:title" content={`Configurar notificações do Paçoca`}/>
                        <meta property="og:description" content={`Configurar notificações`}/>
                        <meta property="og:image" content="/img/link-preview.png?v=1" />
                        <meta property="og:image:width" content="1200" />
                        <meta property="og:image:height" content="630" />
                        <meta property="og:url" content={window.location.href}/>
                        <meta property="og:type" content="website"/>
                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content={`Configurar notificações do Paçoca`}/>
                        <meta name="twitter:description" content={`Configurar notificações`}/>
                        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>

                    {audios.map((audio) => {
                        const id = audio.file.replaceAll("/", "_");
                        const isActive = selectedAudio === id ? "active" : "";

                        return (
                            <div key={id} className={`audio-item`}>
                                <div className={`div-audio item-${isActive}`} onClick={() => playPreview(audio.file)}>
                                    <div className="text">
                                        <button className="btn"><Bell className="icon-settings" data-feather="bell"/></button>
                                        <span>{audio.name}</span>
                                    </div>
                                    <div>
                                        <button onClick={() => setNotificationSound(audio.file)} className="btn-sm btn link-blue">Selecionar</button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </Screen>
        </>
    );
};

export default NotificationsSettings;